import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StatusDisplayTable } from '../../../../components';
import { spaces } from '../../../../utils/constants';
import dayjs from '../../../../utils/dayjsHelper';
import { timestampToDate } from '../../../../utils/tools';
import {
    activatedSpacesStatusOptions,
    expirationDateStatusOptions,
    sepaStatusOptions,
} from '../../shared';
import { subscriptionStatusOptions } from '../../shared/adminUsersUtils';

/**
 * @description all status properly displayed based on item's name
 */
const SpaceManagementStatus = ({
    mode,
    name,
    accountData,
    subscriptionData,
    spaceName,
    billingName,
}) => {
    const expirationDate = accountData?.[mode + 'ExpirationDate'];
    const { t } = useTranslation();

    switch (name) {
        case mode + 'KitStatus':
            return (
                <StatusDisplayTable
                    status={
                        accountData?.[spaceName] !== '0'
                            ? 'ACTIVATED'
                            : 'NOTACTIVATED'
                    }
                    statusOptions={activatedSpacesStatusOptions}
                    i18TextBase="admin.users.table.activatedSpacesFilter"
                />
            );
        case mode + 'KitSEPAStatus':
            return (
                <StatusDisplayTable
                    status={accountData?.[billingName].status}
                    statusExtension={
                        accountData?.[billingName].status === 'SIGNED'
                            ? timestampToDate(
                                  accountData?.[billingName].subscribedAt,
                              )
                            : null
                    }
                    statusOptions={sepaStatusOptions}
                    i18TextBase="admin.users.table.sepaStatusFilter"
                />
            );
        case mode + 'KitExpirationDateMode':
            return (
                <StatusDisplayTable
                    status={
                        expirationDate === 0 || expirationDate < dayjs().unix()
                            ? 'EXPIRED'
                            : 'NOTEXPIRED'
                    }
                    statusOptions={expirationDateStatusOptions}
                    customValue={dayjs
                        .unix(accountData?.[mode + 'ExpirationDate'])
                        .format('DD/MM/YYYY')}
                />
            );
        case mode + 'KitContributionMode':
            return (
                <StatusDisplayTable
                    status={subscriptionData?.contribution_mode || 'NONE'}
                    statusOptions={subscriptionStatusOptions}
                    customValue={t(
                        `admin.user.contributionMode.${
                            subscriptionData?.contribution_mode.toLowerCase() ||
                            'none'
                        }`,
                    )}
                />
            );
        default:
            return null;
    }
};

SpaceManagementStatus.propTypes = {
    accountData: PropTypes.object,
    subscriptionData: PropTypes.object,
    mode: PropTypes.oneOf(Object.values(spaces)).isRequired,
    name: PropTypes.string.isRequired,
    spaceName: PropTypes.string.isRequired,
    billingName: PropTypes.string.isRequired,
};

export default SpaceManagementStatus;
